<template>
  <div>
    <store-add-new
        :is-add-new-store-sidebar-active.sync="isAddNewStoreSidebarActive"
        :id = "id"
        :data="storeData"
        @refetch-data="refetchData"
        v-if="ability.can('create','stores')"
    >

    </store-add-new>

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="handleCreate"
              >
                <span class="text-nowrap">Add Store</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

    <b-table
        ref="refStoreListTable"
        class="store-relative"
        :items="fetchStores"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
    >
    <template #cell(website)="data">
        <a :href="data.item.website" target="_blank">{{data.item.website}}</a>
    </template>
    <template #cell(facebook_link)="data">
        <a :href="data.item.facebook_link" target="_blank">{{data.item.facebook_link}}</a>
    </template>
    <template #cell(ig_link)="data">
        <a :href="data.item.ig_link" target="_blank">{{data.item.ig_link}}</a>
    </template>

    <template #cell(is_active)="data">
        <feather-icon 
        v-if="data.item.is_active"
        icon="CheckIcon"
        size="18"
        class="mr-50 text-success"
        />
    </template>

    <template #cell(actions)="data">
        <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item v-if="ability.can('update','stores')" @click="handleEdit(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="ability.can('delete', 'stores') && false" @click="confirmDelete(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
    </template>
    </b-table>  
    <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalStores"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import storeStoreModule from "../storeStoreModule";
import useStoresList from "./useStoresList";
import StoreAddNew from "./StoreListAddNew.vue"

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    StoreAddNew,
  },
  methods:{
      handleCreate(){
          this.id = 0
          this.resetStoreData()
          this.isAddNewStoreSidebarActive = true
      },
      handleEdit(item){
        this.id = item.id
        this.storeData = {...item}
        /*
        this.storeData.id = item.id
        this.storeData.name = item.name
        this.storeData.address = item.address
        this.storeData.phone = item.phone
        this.storeData.email = item.email
        this.storeData.website = item.website
        console.log(this.storeData)
        */
        this.isAddNewStoreSidebarActive = true
      }, 
      resetStoreData(){
        this.storeData = {
            id: 0,
            name: '',
            address: '',
            phone: '',
            email: '',
            website: '',
            facebook_link: '',
            ig_link: '',
            google_map: '',
            is_active: true,
        }
      },
      confirmDelete(id){
        this.$swal({
        title: 'Are you sure?',
        text: 'Your action is final and you will not be able to retrieve the store.',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      .then(result => {
        if (result.value) {
          this.$store.dispatch("setting-store/deleteStore", {'id': id})
          .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                showClass: {
                  popup: 'animate__animated animate__bounceIn',
                },
                buttonsStyling: false,
              })
              this.refetchData()
          }).catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                showClass: {
                  popup: 'animate__animated animate__bounceIn',
                },
                buttonsStyling: false,
              })

          })
        }
      })
      },
  },
  data(){
    return {
        id:0,
        storeData:{},
    }  
  },
  setup() {
    const SETTING_HOLIDAY_STORE_MODULE_NAME = "setting-store";

    if (!store.hasModule(SETTING_HOLIDAY_STORE_MODULE_NAME))
      store.registerModule(
        SETTING_HOLIDAY_STORE_MODULE_NAME,
        storeStoreModule
      );

    onUnmounted(() => {
      if (store.hasModule(SETTING_HOLIDAY_STORE_MODULE_NAME))
        store.unregisterModule(SETTING_HOLIDAY_STORE_MODULE_NAME);
    });

    const isAddNewStoreSidebarActive = ref(false);

    const {
      fetchStores,
      tableColumns,
      perPage,
      currentPage,
      totalStores,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refStoreListTable,
      refetchData,
      ability,
    } = useStoresList();

    return {
      //Sidebar
      isAddNewStoreSidebarActive,

      fetchStores,
      tableColumns,
      perPage,
      currentPage,
      totalStores,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refStoreListTable,
      refetchData,
      avatarText,
      ability,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>